import moment from 'moment'

export const START = moment().format('YYYY-MM-DD')
export const END = moment().format('YYYY-MM-DD')
export const SELLERS_BOOST_LIST = [5]
export const COLORS = ['#6366f1', '#3b82f6', '#7c3aed', '#a78bfa', '#818cf8', '#2563eb', '#8b5cf6', '#6d28d9']
export const FUNNEL_COLORS = ['#3b82f6', '#4b78f2', '#5a6eee', '#6a64ea', '#7a5ae6', '#6d4de0', '#7c3aed']
